<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>机构</el-breadcrumb-item>
        <el-breadcrumb-item>推广商品</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">推广商品</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="ProductCreateDialog = true">新建</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="商品名称"
                      prop="name">
          <el-input v-model="query.product_name_keyword"
                    placeholder="输入商品名称"
                    @input="fetchList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="商品类型"
                      prop="ref_type">
          <el-select v-model="query.product_types"
                     clearable
                     placeholder="请选择"
                     style="width: 150px"
                     @change="fetchList(true)">
            <el-option v-for="item in filter.refTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务对象"
                      prop="ref_type">
          <el-select v-model="query.service_user_types"
                     clearable
                     placeholder="请选择"
                     style="width: 150px"
                     @change="fetchList(true)">
            <el-option v-for="item in filter.level"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专属机构"
                      prop="company_ids">
          <el-select v-model="query.ref_cid"
                     filterable
                     remote
                     reserve-keyword
                     placeholder="请选择机构简称"
                     style="width: 250px"
                     clearable
                     @change="fetchList(true)">
            <el-option v-for="item in filter.companies"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">商品列表</h3>
        <el-radio-group v-model="query.foster_types"
                        size="small"
                        @change="fetchList(true)">
          <el-radio-button :label="1">渠道分销</el-radio-button>
          <el-radio-button :label="2">分享推广</el-radio-button>
        </el-radio-group>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  v-loading="listLoading"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80px"
                           align="center">
          </el-table-column>
          <el-table-column prop="goods_name"
                           label="商品类型"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span>{{ formatRef_type(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品名称"
                           width="300px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div style="text-align:left;">{{scope.row.product_name}}</div>
            </template>
          </el-table-column>
          <el-table-column label="推广类型"
                           width="120px"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="mini"
                      :type="scope.row.foster_type == 2 ? 'success' : ''">{{ formatFosterType(scope.row.foster_type) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column v-if="isPurchaseList"
                           label="服务对象"
                           width="120px"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="mini"
                      :type="scope.row.service_user_type==1?'':'success'">{{scope.row.service_user_type==1?'学员':'加盟商'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="采购/分佣比例"
                           width="120px"
                           align="center">
            <template slot-scope="scope">
              <span>{{ formatRate(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="isPurchaseList"
                           prop="product_name"
                           label="起订份数"
                           width="150px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ Number(scope.row.foster_type || 1) === 1 && scope.row.base_order_count !== null && scope.row.base_order_count !== undefined ? `${scope.row.base_order_count}份` : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="120px"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="mini"
                      :type="scope.row.status==1?'':'success'">{{scope.row.status==1?'上线':'下线'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
                           label="商品分类"
                           width="180px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatCategories(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="sort"
                           label="排序值"
                           width="180px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.sort}}
            </template>
          </el-table-column>
          <el-table-column
                           label="专属机构"
                           width="180px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatCompanies(scope.row) }}
            </template>
          </el-table-column>

          <el-table-column prop="creator_admin_nickname"
                           label="创建人"
                           width="180px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.creator_admin_nickname}}
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="180px"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD hh:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="修改时间"
                           width="180px"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD hh:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="160px"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="openEdit(scope.row)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleOnline(scope.row)">{{ scope.row.status==1?'下线' :'上线'}}</el-link>
              <el-link type="danger"
                       :underline="false"
                       @click="handleToRemove(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <ProductCreate :visible="ProductCreateDialog"
                   @close="ProductCreateDialog=false"
                   @submit="fetchList()" />
    <ProductEdit :visible="ProductEditDialog"
                 @close="ProductEditDialog=false"
                 :content="ProductEditContent"
                 @submit="fetchList()" />

  </div>
</template>

<script>
import {
  warrantProductlist,
  deleteWarrantProduct,
  updateWarrantProduct,
} from '@/api/warrant'
import { institutionList } from '@/api/common'
import ProductCreate from '@/components/dialog/warrant/ProductCreate.vue'
import ProductEdit from '@/components/dialog/warrant/ProductEdit.vue'

export default {
  components: {
    ProductCreate,
    ProductEdit,
  },
  computed: {
    isPurchaseList() {
      return Number(this.query.foster_types) === 1
    },
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        foster_types: 1,
      },
      pageTotal: 10,
      results: [],
      listLoading: false,
      listRequestId: 0,
      filter: {
        companies: [],
        refTypes: [
          { label: '课程', value: '1' },
          { label: '题库', value: '2' },
          { label: '专栏', value: '3' },
          { label: '资料', value: '4' },
        ],
        level: [
          { label: '学员', value: '1' },
          { label: '加盟商', value: '2' },
        ],
      },
      ProductCreateDialog: false,
      ProductEditDialog: false,
      ProductEditContent: {},
    }
  },
  created() {
    this.fetchList()
    this.fetchInstitutionList()
  },
  methods: {
    fetchInstitutionList() {
      institutionList({ isPaging: 0 }).then((res) => {
        this.filter.companies = res.list || []
      })
    },
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = { ...this.query }
      params.foster_types = Number(params.foster_types || 1)
      const requestId = ++this.listRequestId
      this.listLoading = true
      warrantProductlist(params)
        .then((res) => {
          if (requestId !== this.listRequestId) return
          this.results = res.list || []
          this.pageTotal = res.count || 0
          this.listLoading = false
        })
        .catch(() => {
          if (requestId === this.listRequestId) this.listLoading = false
        })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchList()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    openEdit(row) {
      this.ProductEditContent = JSON.parse(JSON.stringify(row))
      this.ProductEditDialog = true
    },

    handleToRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          deleteWarrantProduct({ ids: [row.id] }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchList()
          })
        })
        .catch(() => {})
    },
    handleOnline(row) {
      let obj = {
        id: row.id,
        status: !row.status,
      }
      updateWarrantProduct(obj).then((res) => {
        this.$message.success(`成功`)
        this.fetchList()
      })
    },
    formatRef_type(row) {
      const obj = {
        0: '无',
        1: '课程',
        2: '题库',
        3: '专栏',
        4: '资料',
        5: '文章',
        6: '学长',
        7: '联报',
      }
      return obj[row.product_type] || ''
    },
    formatFosterType(value) {
      const types = {
        1: '渠道分销',
        2: '分享推广',
        3: '主理人合作',
        4: '机构合作',
      }
      return types[value] || '--'
    },
    formatRate(row) {
      if (Number(row.foster_type || 1) === 1) {
        return row.sale_percent === null || row.sale_percent === undefined
          ? '--'
          : `${row.sale_percent}%`
      }
      if (Number(row.foster_type) === 2) {
        return row.recommend_fee_percent === null ||
          row.recommend_fee_percent === undefined
          ? '--'
          : `${Number(row.recommend_fee_percent * 100)}%`
      }
      return '--'
    },
    formatCategories(row) {
      if (Array.isArray(row.arr_ref_category)) {
        const names = row.arr_ref_category
          .map((item) => item.category_name)
          .filter(Boolean)
        return names.length ? names.join('、') : '--'
      }
      return row.category_name || '--'
    },
    formatCompanies(row) {
      if (Array.isArray(row.arr_ref_company)) {
        const names = row.arr_ref_company
          .map((item) => item.company_name)
          .filter(Boolean)
        return names.length ? names.join('、') : '--'
      }
      return row.ref_company_names || '--'
    },
  },
}
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
